module.exports = __webpack_public_path__ + "img/web2.d617621d.svg";